export const checkboxWrapper = {
    '> div': {
        margin: 0,
        padding: 0,
    },
}
